import { IFeatureFlagProvider } from '@sennder/senn-node-microfrontend-interfaces'
import { getFlag, watchFlag, trackLDEvent } from './core'

export const featureFlagProvider: IFeatureFlagProvider = {
  getFeatureFlag: (flag) => getFlag(flag),
  watchFeatureFlag: (flag, onChange) => watchFlag(flag, onChange),
  trackEvent: (key, data, metricValue) => trackLDEvent(key, data, metricValue),
}
